import type { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import type { Observable } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);

  // Clone the request object
  let newReq = req.clone();

  // Request
  //
  // If the id token exists, add the Authorization header.
  // The server will validate the token and return a "401 Unauthorized" response
  // if the token is expired or invalid. Our response interceptor will catch this
  // and delete the access token from local storage while logging the user out.
  if (authService.idToken) {
    newReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + authService.idToken),
    });
  }

  return next(newReq);
};
